import { renderRoutes } from 'react-router-config';
import { IRouteProps } from '../../../model';

export const TemplateEmpty = (props: IRouteProps) =>
  renderRoutes(props.route?.routes);
